<!-- <pre><code>{{ data | json }}</code></pre>
<button class="btn" (click)="downloadFile()">download</button> -->

<div class="row align-items-center">
  <div class="col-12 col-md-6">
    <app-gallery [images]="images"></app-gallery>
    <!-- <gallery [items]="images" thumbPosition="bottom"></gallery> -->
  </div>
  <div class="col-12 col-md-6">
    <h1>{{ data.name }}</h1>

    <div *ngIf="data.licence_date || data.licence_description">
      <p class="label">Zakres licencji:</p>
      <div class="licence_description" *ngIf="data.licence_description" [innerHTML]="data.licence_description"></div>
      <p *ngIf="data.licence_date">Licencja ważna do: {{ data.licence_date }}</p>
    </div>

    <div *ngIf="data.post_description">
      <p class="label">Treść posta:</p>
      <div  class="post_description" [innerHTML]="data.post_description"></div>
      <button class="post_description_btn" (click)="copyToClipboard(data.post_description)">
        KOPIUJ TEKST
      </button>
    </div>

    <button class="btn btn--black my-3" *ngIf="data.files?.length === 1" (click)="downloadFileId(data.files[0].id, data.files[0])">Pobierz</button>

    <div class="btn-group" dropdown *ngIf="data.files?.length > 1" style="position: relative;">
      <button id="button-basic" dropdownToggle type="button" class="btn btn--black my-3 dropdown-toggle" [disabled]="(download$ | async)?.state !== 'PENDING' || (download$ | async)?.state !== 'IN_PROGRESS'">
        Pobierz <span class="caret"></span>
      </button>
      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
          role="menu" aria-labelledby="button-basic">
        <li role="menuitem" *ngFor="let file of data.files">
          <!-- <app-download-item [file]="file" [data]="data" ()></app-download-item> -->
          <button class="dropdown-item" type="button" (click)="downloadFileId(file.id, file)">
            {{ (file.description && file.description != 'null') ? file.description : (file.path.split('.').pop() ) }}
          </button>
        </li>
        <li class="divider dropdown-divider"></li>
        <li role="menuitem">
          <button class="dropdown-item" type="button" (click)="downloadZipFile()">
            Pobierz wszystkie
          </button>
        </li>
      </ul>
    </div>

    <div class="meter" *ngIf="(download$ | async)?.state === 'IN_PROGRESS'">
      <span [style.width.%]="(download$ | async)?.progress"></span>
    </div>

  </div>
</div>

